
export default {
  name: 'MegasredaContentPostFeedCardTelegram',
  props: {
    post: {
      type: Object,
      default: null,
    },
    isHasComment: {
      type: Boolean,
      default: false,
    },
    statistics: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      streamsVisibleCount: 3,
    }
  },
  computed: {
    isAuthor() {
      if (this.post?.author?._id) {
        return this.$auth?.user?._id === this.post.author._id
      } else {
        return false
      }
    },
    thematicStreams() {
      return this.post.streams.filter((stream) => stream.type === 'THEMATIC')
    },
    isClient() {
      return !!this.post?.author?.isClient
    },
    isAdmin() {
      return !!this.$auth?.user?.roles?.some((role) =>
        ['ADMIN', 'MODERATOR'].includes(role)
      )
    },
    streams() {
      return this.thematicStreams?.slice(0, this.streamsVisibleCount)
    },
    shareTitle() {
      return this.post?.description
    },
    shareDescription() {
      return this.post?.description
    },
  },
  methods: {
    inView({ isInView }) {
      if (isInView) {
        this.setShow()
      }
    },
    setShow() {
      this.$axios.$post('/activity/show/article', {
        username: this.post.author.username,
        articleId: this.post._id,
      })
    },
    closeMenu() {
      this.isShowStreamsPopUp = false
    },
  },
}
